import {
    getDonationQuery,
    MESSAGE_FILTER_VALUE,
    TRANSACTION_FILTER_VALUE,
} from '@givelify/api';
import { IntegrationPaginatedResponse } from '@givelify/givelify-ui';
import {
    ApiResponse,
    getAxiosClient,
    makeApiRequest,
    TimeFrameValue,
} from '@givelify/utils';
import { DonationRow } from 'api/models';
import axios, { CancelTokenSource } from 'axios';

const sortValues = [
    'date-asc',
    'date-desc',
    'donor_name-asc',
    'donor_name-desc',
];

let infiniteLoaderDataCancelTokenSource: CancelTokenSource;

export const getDonationsQuery = (
    doneeId: number,
    pageNumber: number,
    timeFrame: TimeFrameValue,
    transactionFilter: TRANSACTION_FILTER_VALUE,
    envelopeIds: number[],
    messageFilter: MESSAGE_FILTER_VALUE[],
    search?: string,
    sortField?: string,
) => {
    const sort = sortValues.includes(sortField)
        ? sortField.split('-')[0]
        : 'date';
    const order = sortField.split('-')[1] || 'desc';
    const donationsQueryString = getDonationQuery({
        timeFrame,
        transactionFilter,
        page: pageNumber,
        envelopeIds,
        messageFilter,
        search,
        sort,
        order,
    });
    return `/donees/${doneeId}/donations${donationsQueryString}`;
};

export const getDonationActivityData = async (
    doneeId: number,
    pageNumber: number,
    timeFrame: TimeFrameValue,
    transactionFilter: TRANSACTION_FILTER_VALUE,
    envelopeIds: number[],
    messageFilter: MESSAGE_FILTER_VALUE[],
    search?: string,
    sortField?: string,
): Promise<ApiResponse<IntegrationPaginatedResponse<DonationRow>>> => {
    infiniteLoaderDataCancelTokenSource?.cancel();
    infiniteLoaderDataCancelTokenSource = axios.CancelToken.source();
    const donationsUrl = getDonationsQuery(
        doneeId,
        pageNumber,
        timeFrame,
        transactionFilter,
        envelopeIds,
        messageFilter,
        search,
        sortField,
    );

    const donationsHttpRequest = getAxiosClient().get(donationsUrl, {
        cancelToken: infiniteLoaderDataCancelTokenSource.token,
    });
    return makeApiRequest<IntegrationPaginatedResponse<DonationRow>>(
        donationsHttpRequest,
    );
};
